import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import ManualLayout from '../../components/ManualLayout';
import ManualChapterTitle from '../../components/ManualChapterTitle';
import ManualHero from '../../components/ManualHero';
import ManualSection from '../../components/ManualSection';
import StreamField from '../../components/StreamField';
import { GlossaryContext } from '../../components/GlossaryText';

// Consecutive chapter level modules share one StreamField so they get the
// same gaps between them as inside a section.
const groupContent = (content) =>
    content.reduce((groups, item) => {
        const last = groups[groups.length - 1];

        if (item.component === 'section') {
            groups.push(item);
        } else if (last && last.component !== 'section') {
            last.items.push(item);
        } else {
            groups.push({ id: item.id, items: [item] });
        }

        return groups;
    }, []);

const ManualPage = ({
    header = {},
    manual = null,
    navigation = [],
    pagination = {},
    hero = null,
    icon = '',
    title = '',
    intro = '',
    content = [],
    glossary = [],
}) => {
    const hasHero = !!hero?.logo?.url || !!hero?.image?.url;
    return (
        <GlossaryContext.Provider value={glossary}>
            <ManualLayout
                header={header}
                manual={manual}
                navigation={navigation}
                pagination={pagination}>
                {hasHero ? (
                    <ManualHero {...hero} title={title} intro={intro} />
                ) : (
                    <ManualChapterTitle
                        icon={icon}
                        title={title}
                        intro={intro}
                    />
                )}

                {groupContent(content).map((item, index) =>
                    item.component === 'section' ? (
                        <ManualSection
                            key={item.id || index}
                            title={item.title}
                            anchor={item.anchor}
                            hasLine={item.hasLine}>
                            <StreamField
                                items={item.content}
                                modifiers={['Manual']}
                            />
                        </ManualSection>
                    ) : (
                        <StreamField
                            key={item.id || index}
                            items={item.items}
                            modifiers={['Manual']}
                        />
                    )
                )}
            </ManualLayout>
        </GlossaryContext.Provider>
    );
};

ManualPage.propTypes = {
    header: PropTypes.object,
    manual: PropTypes.object,
    navigation: PropTypes.array,
    pagination: PropTypes.object,
    hero: PropTypes.object,
    icon: PropTypes.string,
    title: PropTypes.string,
    intro: PropTypes.string,
    content: PropTypes.array,
    glossary: PropTypes.arrayOf(PropTypes.string),
};

export default basePageWrap(ManualPage);
